import React, { useContext, useEffect, useRef, useState } from 'react'
import { fetchEodSubmission } from '../services/fetchEodSubmission'
import { DContext } from '../../context/Datacontext'
import { EodSubmissionReport } from '../../hooks/DownLoadExcel/EodSubmissionReport'
import { FaSearch } from "react-icons/fa";
import { renderCapitalize } from '../../utils/renderCapitalize';


export const EodReport = () => {
    const { BeURL, showAlert, currentUser } = useContext(DContext)
    const [eodlist, setEodList] = useState([]);
    const searchRef = useRef();
    const [searchTerm, setSearchTerm] = useState('');


    const fetchEODS = async () => {
        await fetchEodSubmission({ BeURL, showAlert, setEodList, id: currentUser._id, searchTerm })
    }
    useEffect(() => {
        fetchEODS()
    }, [BeURL])


    const handleSearch = () => {
        fetchEODS()
    }

    const handleKeyDown = (e) => {

        if (e.key === "Enter") {
            handleSearch()
        }
    }


    const handleDownLoadExcel = () => {

        EodSubmissionReport({ eodlist, showAlert, currentUser })
    }

    return (
        <div className=' w-full min-h-[80vh] space-y-3 mt-8 '>

            <h1 className='text-center text-xl font-semibold leading-3'>EOD Submission Report</h1>
            <p className='text-gray-500 text-center text-sm '>Tracks daily candidate submissions, updating only status changes when the same candidate is resubmitted.</p>

            <div className='flex justify-end' >
                <button className='bg-primary-400 rounded-lg py-1 px-3 text-white font-semibold' onClick={handleDownLoadExcel}> Download Excel</button>
            </div>


            {/* Search & Create */}
            < div className="flex flex-wrap gap-4 mx-11" >
                <div className="flex flex-1 max-w-md ">

                    <input
                        ref={searchRef}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        type="search"

                        className="flex-1 border rounded-l px-3 py-2 focus:outline-none"
                        placeholder="Search by Submitted by, Client, Spoc..."
                        onKeyDown={e => handleKeyDown(e)}
                    />
                    <button onClick={handleSearch} className={`px-4 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-white rounded-r flex items-center`}
                        title="Apply search">
                        <FaSearch className="mr-2" />Search
                    </button>
                </div>

            </div >

            <div className="overflow-x-auto bg-white rounded-xl shadow-md mx-10">
                <div className="">
                    <table className="min-w-full border-collapse">
                        <thead className="bg-secondary-700 text-secondary-400 sticky top-0 z-10">
                            <tr>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">S.No</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Recent Update</th>

                                <th className="p-3 whitespace-nowrap border text-center font-medium">Client</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Client Manager(spoc)</th>

                                <th className="p-3 whitespace-nowrap border text-center font-medium">Reporting Manager</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Reporting Teamlead</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">SAN SPOC</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Submitted By</th>

                                <th className="p-3 whitespace-nowrap border text-center font-medium">JobCode</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Client JobCode</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Title</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Job Location</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Job Type</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Skills</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Status</th>

                                <th className="p-3 whitespace-nowrap border text-center font-medium">Candidate Name</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Mobile Number</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Email</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Candidate Location</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Experience</th>
                                {/* <th className="p-3 whitespace-nowrap border text-center font-medium">Relevant Experience</th> */}
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Current company</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Current CTC</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Expected CTC</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Notice period</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Negotiable Notice Period</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">LWD</th>

                                <th className="p-3 whitespace-nowrap border text-center font-medium">Profile SubmittedOn</th>

                                <th className="p-3 whitespace-nowrap border text-center font-medium">Recent Status</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Status UpdatedOn</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Comment</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Sub Category</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Scheduled Date</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Date of Joining</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Offered CTC</th>
                                <th className="p-3 whitespace-nowrap border text-center font-medium">Employee Id</th>

                            </tr>
                        </thead>
                        <tbody>
                            {eodlist.length > 0 ? (
                                eodlist.map((d, i) => (
                                    <tr
                                        key={i}
                                        className="hover:bg-blue-50 transition border-b border-slate-100"
                                    >
                                        <td className="p-3 whitespace-nowrap border text-center ">{i + 1}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d?.updatedAt ? new Date(d?.updatedAt).toLocaleString("en-GB") : "-"}</td>

                                        <td className="p-3 whitespace-nowrap border text-center  text-primary-500 cursor-pointer">{renderCapitalize(d?.client?.name ?? '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center">{renderCapitalize(d?.spoc?.name || '-')}</td>

                                        <td className="p-3 whitespace-nowrap border text-center">{renderCapitalize(d.reportingManager?.name || '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.reportingTeamLead?.name || '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.primaryRecruiter?.name || '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.submittedBy?.name || '-')}</td>

                                        <td className="p-3 whitespace-nowrap border text-center ">{d.job?.jobCode ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.job?.clientJobCode ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.job?.title || '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.job?.location || '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.job?.type || '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">
                                            {d.job?.skills?.length > 0 ? d.job.skills.join(" , ") : "-"}
                                        </td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.job?.status ?? '-')}</td>

                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.candidate?.name || '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.number ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.email ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.address ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">
                                            {(d.candidate?.exp && d.candidate?.exp !== undefined && d.candidate?.exp !== "")
                                                ? d.candidate.exp
                                                : "-"}
                                        </td>
                                        {/* <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.relExp ?? '-'}</td> */}
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.candidate?.currentCompany ?? '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.ctc ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.expectedCtc ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.noticePeriod ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.negotiableNoticePeriod ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.candidate?.lwd && !isNaN(new Date(d.candidate?.lwd)) ? new Date(d.candidate?.lwd).toLocaleDateString("en-GB") : "-"}</td>


                                        <td className="p-3 whitespace-nowrap border text-center">{d.profileSubmittedOn && !isNaN(new Date(d.profileSubmittedOn)) ? new Date(d.profileSubmittedOn).toLocaleString("en-GB") : "-"}
                                        </td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.recentStatus?.status ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.recentStatus?.timestamp && !isNaN(new Date(d.recentStatus?.timestamp)) ? new Date(d.recentStatus?.timestamp).toLocaleString("en-GB") : "-"}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.recentStatus?.comment ?? '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{renderCapitalize(d.recentStatus?.subcategory ?? '-')}</td>
                                        <td className="p-3 whitespace-nowrap border text-center">  {d.recentStatus?.scheduledDate
                                            ? new Date(d.recentStatus.scheduledDate).toLocaleDateString("en-GB")
                                            : "-"}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.recentStatus?.doj
                                            ? new Date(d.recentStatus.doj).toLocaleDateString("en-GB")
                                            : "-"}</td>
                                        <td className="p-3 whitespace-nowrap border text-center">{d.recentStatus?.offeredCtc ?? '-'}</td>
                                        <td className="p-3 whitespace-nowrap border text-center ">{d.recentStatus?.empId ?? '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="text-center py-4 text-gray-500">
                                        No EOD reports found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
